import gql from 'graphql-tag'

export const LEVEL_FIELDS = gql`
  fragment levelFields on level {
    id
    name
    createdAt: created_at
  }
`

export const SUBJECT_FIELDS = gql`
  fragment subjectFields on subject {
    id
    name
    createdAt: created_at
    updatedAt: updated_at
  }
`

export const LOCATION_FIELDS = gql`
  fragment locationFields on location {
    id
    name
    createdAt: created_at
    updatedAt: updated_at
  }
`

export const ROLE_FIELDS = gql`
  fragment roleFields on role {
    id
    name
    createdAt: created_at
    updatedAt: updated_at
  }
`

export const USER_ROLES_FIELDS = gql`
  ${ROLE_FIELDS}
  fragment userRoleFields on user_role {
    role {
      ...roleFields
    }
    createdAt: created_at
  }
`

export const USER_FIELDS = gql`
  ${USER_ROLES_FIELDS}
  ${LOCATION_FIELDS}
  fragment userFields on user {
    id
    title
    firstName: firstname
    middleName: middlename
    lastName: lastname
    nickName: nickname
    email
    birthDate: birth_date
    avatarUrl: avatar_url
    createdAt: created_at
    updatedAt: updated_at
    userLocations: user_locations {
      location {
        ...locationFields
      }
    }
    userRoles: user_roles {
      ...userRoleFields
    }
  }
`

export const USER_GROUP_FIELDS = gql`
  ${USER_FIELDS}
  ${ROLE_FIELDS}
  fragment userGroupFields on user_group {
    user {
      ...userFields
    },
    role {
      ...roleFields
    }
  }
`

export const GROUP_FIELDS = gql`
  ${USER_GROUP_FIELDS}
  fragment groupFields on group {
    id
    name
    type
    userGroups: user_groups {
      ...userGroupFields
    }
  }
`

export const MESSAGE_GROUP_FIELDS = gql`
  ${GROUP_FIELDS}
  fragment messageGroupFields on message_group {
    group {
      ...groupFields
    }
  }
`

export const ASSET_FIELDS = gql`
  fragment assetFields on asset {
    id
    class
    description
    isShared: is_shared
    type
    url
  }
`

export const CONTENT_ASSET_FIELDS = gql`
  ${ASSET_FIELDS}
  fragment contentAssetFields on content_asset {
    asset {
      ...assetFields
    }
  }
`

export const CONTENT_FIELDS = gql`
  ${CONTENT_ASSET_FIELDS}
  fragment contentFields on content {
    id
    title
    body
    annotation
    contentAssets: content_assets {
      ...contentAssetFields
    }
  }
`

export const MESSAGE_FIELDS = gql`
  ${USER_FIELDS}
  ${CONTENT_FIELDS}
  ${MESSAGE_GROUP_FIELDS}
  fragment messageFields on message {
    id
    type
    status
    data
    senderUser: user {
      ...userFields
    }
    recipientUser: userByRecipientUserId {
      ...userFields
    }
    content {
      ...contentFields
    }
    messageGroups: message_groups {
      ...messageGroupFields
    }
    createdAt: created_at
    updatedAt: updated_at
  }
`

export const ITEM_GROUP_FIELDS = gql`
  ${GROUP_FIELDS}
  fragment itemGroupFields on item_group {
    group {
      ...groupFields
    }
  }
`

export const ITEM_USER_FIELDS = gql`
  ${USER_FIELDS}
  ${ROLE_FIELDS}
  fragment itemUserFields on item_user {
    user {
      ...userFields
    }
    role {
      ...roleFields
    }
  }
`

export const ITEM_SETTINGS_FIELDS = gql`
  ${USER_FIELDS}
  fragment itemSettingFields on item_setting {
    itemId: item_id
    key
    user {
      ...userFields
    }
    value
  }
`

export const ITEM_TEMPLATE_LESSONPLAN_FIELDS = gql`
  ${LEVEL_FIELDS}
  ${SUBJECT_FIELDS}
  fragment itemTemplateLessonplanFields on item_template_lessonplan {
    id
    enhancement
    level {
      ...levelFields
    }
    lesson
    assessment
    objective
    number
    platform
    resources
    status
    subject {
      ...subjectFields
    }
    year
  }
`

export const ITEM_FIELDS = gql`
  ${CONTENT_FIELDS}
  ${ITEM_USER_FIELDS}
  ${ITEM_GROUP_FIELDS}
  ${ITEM_SETTINGS_FIELDS}
  ${ITEM_TEMPLATE_LESSONPLAN_FIELDS}
  fragment itemFields on item {
    id
    type
    order
    event_id
    status
    content {
      ...contentFields
    }
    itemUsers: item_users {
      ...itemUserFields
    }
    itemGroups: item_groups {
      ...itemGroupFields
    }
    itemSettings: item_settings {
      ...itemSettingFields
    }
    lessonPlan: item_template_lessonplan {
      ...itemTemplateLessonplanFields
    }
    startDateTime: start_datetime
    endDateTime: end_datetime
    createdAt: created_at
    updatedAt: updated_at
  }
`

export const EVENT_FIELDS = gql`
  fragment eventFields on event {
    id
    name
    startDatetime: start_datetime
    endDatetime: end_datetime
  }
`
